import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

export default function MyVideos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    setError(false);
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/videos/my-videos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVideos(res.data);
    } catch (err) {
      console.error("Failed to fetch videos:", err);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
        return;
      }
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      pending: "bg-yellow-100 text-yellow-800",
      published: "bg-green-100 text-green-800",
      rejected: "bg-red-100 text-red-800"
    };
    return colors[status] || "bg-gray-100 text-gray-800";
  };

  if (loading) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center">Loading your videos...</div>;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
        <p className="text-gray-600 mb-4">Failed to load videos.</p>
        <button onClick={fetchVideos} className="bg-primary text-white px-4 py-2 rounded-md">Retry</button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-primary mb-6">My Videos</h1>

        {videos.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
            <p>No videos yet.</p>
            <Link to="/submit" className="text-primary hover:underline mt-2 inline-block">Submit your first video</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {videos.map(v => (
              <div key={v.id} className="bg-white rounded-lg shadow p-5">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-xl font-semibold text-primary">{v.verse}</h3>
                  <span className={`inline-block px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadge(v.status)}`}>
                    {v.status}
                  </span>
                </div>
                <div className="text-sm text-gray-500 mb-2">Submitted: {new Date(v.created_at).toLocaleDateString()}</div>
                {v.status === "published" && (
                  <>
                    <div className="text-sm text-gray-500 mb-2">Views: {v.views || 0}</div>
                    {v.youtube_url && (
                      <a
                        href={v.youtube_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline text-sm"
                      >
                        Watch on YouTube →
                      </a>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}